<template>
  <div
    class="group-actions"
    :class="computedClass"
    :style="{ width: props.width }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
export interface IProps {
  direction?: 'row' | 'column'
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  align?: 'start' | 'center' | 'end' | 'stretch'
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly'
  wrap?: boolean
  width?: string
}

const props = withDefaults(defineProps<IProps>(), {
  direction: 'row',
  gap: 'md',
  align: 'center',
  justify: 'start',
  wrap: false,
})

const computedClass = computed(() => ({
  [`group-actions--direction-${props.direction}`]: true,
  [`group-actions--gap-${props.gap}`]: true,
  [`group-actions--align-${props.align}`]: true,
  [`group-actions--justify-${props.justify}`]: true,
  'group-actions--wrap': props.wrap,
}))
</script>

<style scoped lang="scss">
.group-actions {
  display: flex;
  align-items: center;

  &--direction {
    &-row {
      flex-direction: row;
    }

    &-column {
      flex-direction: column;
    }
  }

  &--gap {
    &-xs {
      gap: rem(4px);
    }

    &-sm {
      gap: rem(8px);
    }

    &-md {
      gap: rem(12px);
    }

    &-lg {
      gap: rem(16px);
    }

    &-xl {
      gap: rem(20px);
    }
  }

  &--align {
    &-start {
      align-items: flex-start;
    }

    &-center {
      align-items: center;
    }

    &-end {
      align-items: flex-end;
    }

    &-stretch {
      align-items: stretch;
    }
  }

  &--justify {
    &-start {
      justify-content: flex-start;
    }

    &-center {
      justify-content: center;
    }

    &-end {
      justify-content: flex-end;
    }

    &-between {
      justify-content: space-between;
    }

    &-around {
      justify-content: space-around;
    }

    &-evenly {
      justify-content: space-evenly;
    }
  }

  &--wrap {
    flex-wrap: wrap;
  }
}
</style>
